import React, { useEffect } from "react";
import "./BlogDetail2.css";
import { FaFacebookF, FaInstagram , FaLinkedinIn } from "react-icons/fa";
import blogBg from "../../assets/images/blog2.png"; // final bg for info section
import extraImg from "../../assets/images/data2.jpg"; // enquiry left image

const BlogDetail2 = () => {
  // ========= UPDATED SCROLL ANIMATION FUNCTIONALITY (REPEATABLE) ==========
  useEffect(() => {
    // Define the custom animation classes to observe
    // This list ensures all new animated elements are targeted.
    const classesToObserve = [
      ".slide-in-left-fast",
      ".slide-in-top-smooth",
      ".slide-in-right-subtle",
      ".slide-in-left",
    ];

    const elements = document.querySelectorAll(classesToObserve.join(", "));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            // Remove 'active' when out of view to re-trigger the animation (repeatable animation)
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.2 } // Animation starts when 20% of element is visible
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []); // Run once on mount

  return (
    <>
      {/* ============================================ HERO SECTION ========================================================= */}
      {/* Removed scroll-reveal class from section, only applying animation to overlay */}
      <section
        className="blog-hero-section"
        style={{ backgroundImage: `url(${blogBg})` }}
      >
        {/* HERO OVERLAY: Left से fast स्लाइड-इन (slide-in-left-fast) */}
        <div className="blog-hero-overlay slide-in-left-fast">
          <span className="blog-category">Business</span>

          <h1 className="blog-title">
          Empower Your Business with NMD Infotech’s Data Analytics Services
          </h1>

          <div className="blog-meta">
            <p>
              <i className="fa-solid fa-calendar"></i> December 16, 2024
            </p>
            <p>
              <i className="fa-solid fa-comments"></i> No Comments
            </p>
          </div>
        </div>
      </section>

      {/* =============================================== ENQUIRY + NEWSLETTER SECTION======================================== ================= */}
      {/* ENQUIRY SECTION: ऊपर से smooth scroll (slide-in-top-smooth) */}
      <section className="enquiry-section slide-in-top-smooth">
        {/* LEFT IMAGE */}
        <div
          className="enquiry-left"
          style={{ backgroundImage: `url(${extraImg})` }}
        />

        {/* RIGHT FORM */}
        <div className="enquiry-right">
          <h2 className="enquiry-title">Newsletter</h2>
          <p className="enquiry-text">
            Get free tips and resources right in your inbox, along with 10,000+
            others
          </p>

          <form className="enquiry-form">
            <input type="text" placeholder="Name" />
            <input type="email" placeholder="Email" />
            <button type="submit">Sign Up</button>
          </form>
        </div>
      </section>

      {/* ================================================ INFO SECTION================================================ ================= */}
      {/* Removed scroll-reveal class from section, only applying animation to content */}
      <section
        className="info-section"
        style={{ backgroundImage: `url(${blogBg})` }}
      >
        <div className="info-overlay"></div>
        {/* INFO CONTENT: Right से हल्का स्लाइड-इन (slide-in-right-subtle) */}
        <div className="info-content slide-in-right-subtle">
          <h2 className="info-heading">Empowering Data-Driven Decisions</h2>

          <p>
          In today’s fast-paced, data-driven world, businesses generate immense volumes of data daily. However, raw data alone holds little value unless effectively analyzed to uncover actionable insights. At NMD Infotech, we specialize in transforming complex datasets into meaningful strategies that drive business growth. Our comprehensive data analytics services empower organizations to make informed decisions, streamline operations, and gain a competitive edge. 
          </p>

          <p>
            <strong>The Essence of Data Science:</strong> At its core, data
            science involves collecting, cleaning, analysing, and interpreting
            vast amounts of data. But beyond the technicalities lies a deeper
            goal: uncovering the stories hidden within the numbers. Data
            scientists are modern-day storytellers who bridge the gap between
            complexity and understanding. They transform an overwhelming flood
            of information into knowledge that drives decisions.
          </p>
        </div>
      </section>


      {/* ============================================ LATEST POSTS SECTION =============================================================== */}
      {/* LATEST POSTS: Left से स्लाइड-इन (slide-in-left) */}
      <section className="latest-posts-section slide-in-left">
        <div className="latest-posts-container">
          <div className="posts-list">
            <h2 className="posts-heading">Latest Posts</h2>

            {/* Post 1 */}
            <div className="post-item">
              <img src={require("../../assets/images/post1.png")} alt="Data Science" />
              <div className="post-info">
                <h3>Data Science</h3>
                <p>From Numbers to Knowledge: The Art of Data Science</p>
                <span>16 December 2024</span>
              </div>
            </div>

            {/* Post 2 */}
            <div className="post-item">
              <img src={require("../../assets/images/post2.png")} alt="Empower Your Business" />
              <div className="post-info">
                <h3>Empower Your Business with NMD Infotech’s Data Analytics Services</h3>
                <span>16 December 2024</span>
              </div>
            </div>

            {/* Post 3 */}
            <div className="post-item">
              <img src={require("../../assets/images/post3.png")} alt="NMD Infotech Services" />
              <div className="post-info">
                <h3>NMD Infotech Services</h3>
                <p>Unlocking Business Potential: How NMD Infotech Services Can Propel Your Growth</p>
                <span>12 December 2024</span>
              </div>
            </div>

            {/* Post 4 */}
            <div className="post-item">
              <img src={require("../../assets/images/post4.png")} alt="Digital Marketing vs Traditional Marketing" />
              <div className="post-info">
                <h3>Digital Marketing vs Traditional Marketing</h3>
                <span>31 March 2024</span>
              </div>
            </div>

            {/* Post 5 */}
            <div className="post-item">
              <img src={require("../../assets/images/post5.png")} alt="Tips for Digital Marketing" />
              <div className="post-info">
                <h3>Tips for Digital Marketing</h3>
                <span>27 March 2024</span>
              </div>
            </div>

            {/* Post 6 */}
            <div className="post-item">
              <img src={require("../../assets/images/post6.png")} alt="Tip’s Of Digital Marketing For Small Business" />
              <div className="post-info">
                <h3>Tip’s Of Digital Marketing For Small Business</h3>
                <span>March 2014</span>
              </div>
            </div>
          </div>

          <div className="posts-image">
            <img src={require("../../assets/images/data2.jpg")} alt="Blog Highlight" />
          </div>
        </div>
      </section>




      {/* ============================================== DATA SCIENCE FULL CONTENT SECTION =========================================================================== */}
    
    <section className="ds-journey-section slide-in-top-smooth">
      <div className="ds-container">
        {/* Heading */}
        <h2 className="ds-title">Our Data Analytics Process</h2>

        <div className="ds-card-grid">
          <div className="ds-card">
            <h3>1. Data Collection</h3>
            <p>Identify data sources (CRM, Social Media, IoT) and integrate them into a unified system.</p>
          </div>

          <div className="ds-card">
            <h3>2. Data Cleaning</h3>
            <p>Remove duplicates, fix inconsistencies, and prepare data for analysis.</p>
          </div>

          <div className="ds-card">
            <h3>3. Data Modelling</h3>
            <p>Build and refine predictive models using advanced techniques & ML algorithms.</p>
          </div>

          <div className="ds-card">
            <h3>4. Data Visualization</h3>
            <p>Create interactive dashboards with Power BI & Tableau to present insights clearly.</p>
          </div>
        </div>

        {/* Industries */}
        <h2 className="ds-title-small">Industries We Serve</h2>

        <div className="ds-card-grid">
          {[
            "Business Analytics",
            "Healthcare Analytics",
            "Marketing Analytics",
            "Financial Analytics",
            "Social Media Analytics",
            "Sports Analytics",
          ].map((item, index) => (
            <div key={index} className="ds-card small">{item}</div>
          ))}
        </div>

        {/* Tools Section */}
        <h2 className="ds-title-small">Tools & Technologies</h2>
        <div className="ds-card">
          <p><strong>Technologies:</strong> Excel, Python, R, SQL, Power BI, Tableau, ML Frameworks</p>
        </div>

        {/* Custom Solutions */}
        <h2 className="ds-title-small">Custom Solutions</h2>
        <div className="ds-card">
          <p>We design analytics services tailored to your unique business goals.</p>
        </div>

        {/* Success Stories */}
        <h2 className="ds-title-small">Showcasing Success</h2>
        <div className="ds-card">
          <p>Our work has delivered measurable results across industries, from optimizing supply chains to boosting marketing ROI.</p>
        </div>
      </div>
    </section>
 

       
      {/* ============================================ post a comment section =============================================================== */}


       {/* POST COMMENT SECTION: ऊपर से smooth scroll (slide-in-top-smooth) */}
<section className="share-comment-section slide-in-top-smooth">

{/* SHARE BOX */}
<div className="share-box">
  <h3>Share it:</h3>

  <div className="share-icons">
  <a href="https://www.facebook.com/digitalmarketingnmd?mibextid=2JQ9oc" className="icon fb"><FaFacebookF /></a>
            <a href="https://www.instagram.com/nmdinfotech/?igsh=M2lnM205YXZ6b3lp#" className="icon tw"><FaInstagram /></a>
            <a href="https://in.linkedin.com/company/nmd-infotech" className="icon ln"><FaLinkedinIn /></a>
  </div>
</div>

{/* COMMENT FORM — Web3Forms Access Key */}
<div className="glass-form">
  <h2>Leave a Reply</h2>
  <p>Your email address will not be published. Required fields are marked *</p>

  <form
    action="https://api.web3forms.com/submit"
    method="POST"
    className="webform3"
  >
    {/* REQUIRED ACCESS KEY */}
    <input type="hidden" name="access_key" value="YOUR_ACCESS_KEY_HERE" />

    {/* Auto Subject */}
    <input type="hidden" name="subject" value="New Blog Comment Submitted" />

    {/* Comment */}
    <label>Comment *</label>
    <textarea name="comment" placeholder="Write your comment..." required></textarea>

    {/* Name */}
    <label>Name *</label>
    <input type="text" name="name" placeholder="Enter your name" required />

    {/* Email */}
    <label>Email *</label>
    <input type="email" name="email" placeholder="Enter your email" required />

    {/* Website */}
    <label>Website</label>
    <input type="text" name="website" placeholder="Your website (optional)" />

    <div className="checkbox-row">
      <input type="checkbox" />
      <span>Save my info for next time.</span>
    </div>

    <button className="submit-btn">Post Comment</button>
  </form>
</div>

</section>
    </>
  );
};

export default BlogDetail2;